import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 34, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...props}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`overline block ${className}`}>{children}</span>
);

export const SectionHeading = ({ overline, title, subtitle, center = false, light = false }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    {overline && <Overline className="mb-4">{overline}</Overline>}
    <h2
      className={`font-display font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] ${
        light ? "text-[#050505]" : "text-white"
      }`}
    >
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-6 text-base md:text-lg leading-relaxed ${light ? "text-zinc-600" : "text-zinc-400"}`}>
        {subtitle}
      </p>
    )}
  </div>
);
